/* DemoPool · Smoke cursor (hero only)
   The pointer leaves a soft white smoke trail inside the hero; the system cursor is hidden there
   on mouse devices (links, buttons and fields keep their normal cursor), a small glow marks the pointer.
   Mount: <canvas class="dp-smoke" data-dp-smoke aria-hidden="true"></canvas> inside the hero section.
   Additive glow from one pre-rendered sprite (no gradient per particle). Sleeps when idle. Off for reduced motion. */
(() => {
  const cv = document.querySelector('[data-dp-smoke]');
  if (!cv || matchMedia('(prefers-reduced-motion: reduce)').matches || !matchMedia('(hover: hover)').matches) return;   // no cursor on touch screens: no smoke loop
  const host = cv.closest('section') || cv.parentElement;
  const ctx = cv.getContext('2d');
  const RATE = 4, RADIUS = 26, DRAG = .94, LIFT = .06, MAX = 200;   // calmer: fewer, fainter, shorter-lived puffs
  let ps = [], px = 0, py = 0, has = false, inside = false, dpr = 1, W = 0, H = 0, running = false, dot = 0;
  const rand = (a, b) => a + Math.random() * (b - a);

  const sprite = document.createElement('canvas'); sprite.width = sprite.height = 128;
  const sc = sprite.getContext('2d'), sg = sc.createRadialGradient(64, 64, 0, 64, 64, 64);
  sg.addColorStop(0, 'rgba(255,255,255,1)'); sg.addColorStop(1, 'rgba(255,255,255,0)');
  sc.fillStyle = sg; sc.fillRect(0, 0, 128, 128);

  const fit = () => {
    dpr = Math.min(devicePixelRatio || 1, 2);
    const b = cv.getBoundingClientRect(); W = b.width; H = b.height;
    cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  fit();
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(cv); else addEventListener('resize', fit, { passive: true });

  host.addEventListener('pointermove', e => {
    const b = cv.getBoundingClientRect(), x = e.clientX - b.left, y = e.clientY - b.top;
    if (!has) { px = x; py = y; has = true; }
    const vx = x - px, vy = y - py; px = x; py = y; inside = true;
    const n = Math.max(1, Math.min(Math.round(Math.hypot(vx, vy) / 5), RATE));
    for (let i = 0; i < n; i++) ps.push({
      x: px + rand(-6, 6), y: py + rand(-6, 6),
      vx: vx * rand(.1, .34) + rand(-.6, .6), vy: vy * rand(.1, .34) + rand(-.6, .6),
      r: rand(RADIUS * .34, RADIUS), life: 1
    });
    if (ps.length > MAX) ps.splice(0, ps.length - MAX);
    wake();
  }, { passive: true });
  host.addEventListener('pointerleave', () => { inside = false; has = false; }, { passive: true });

  const loop = t => {
    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = 'lighter';               // additive = glow
    for (let i = ps.length - 1; i >= 0; i--) {
      const q = ps[i];
      q.life -= .018;
      if (q.life <= 0) { ps.splice(i, 1); continue; }
      q.vx *= DRAG; q.vy *= DRAG;
      q.vy -= LIFT;
      q.vx += Math.sin((q.y + t * .02) * .01) * .05;         // curl
      q.x += q.vx; q.y += q.vy; q.r += .35;
      ctx.globalAlpha = q.life * .11;
      ctx.drawImage(sprite, q.x - q.r, q.y - q.r, q.r * 2, q.r * 2);
    }
    // the pointer itself: a small steady glow, so the position never gets lost when the smoke fades
    dot += ((inside ? 1 : 0) - dot) * .2;
    if (dot > .01) { ctx.globalAlpha = .35 * dot; ctx.drawImage(sprite, px - 5, py - 5, 10, 10); ctx.globalAlpha = .85 * dot; ctx.drawImage(sprite, px - 2, py - 2, 4, 4); }
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    if (ps.length || dot > .01) requestAnimationFrame(loop); else running = false;   // sleep when idle
  };
  const wake = () => { if (!running) { running = true; requestAnimationFrame(loop); } };
})();
